<template lang="pug">
section#start
  section.banner-area.relative
    .overlay.overlay-bg
    .container
      .row.fullscreen.align-items-center.justify-content-between
        .col-sm-6.selecter
          router-link(to="/start/blood-sugar")
            img.img-fluid(src='static/img/anew.png')
          router-link.link.primary-btn(to="/start/blood-sugar")
            | {{ $t('start.new') }}
            span.lnr.lnr-arrow-right
          p &nbsp;
        .col-sm-6.selecter
          router-link(to="/start/from-code")
            img.img-fluid(src='static/img/fromcode.png')
          router-link.link.primary-btn(to="/start/from-code")
            | {{ $t('start.code') }}
            span.lnr.lnr-arrow-right
          p {{ $t('start.codeMore') }}
      .row
        .col
          router-link.genric-btn.circle.link(to="/")
            span.lnr.lnr-arrow-left
            | &nbsp;
            | {{ $t('controls.back') }}
</template>

<script>
export default {
  name: 'Start',
  components: {
  },
  metaInfo() {
    return {
      title: this.$t('start.meta.title'),
    };
  },
  methods: {
    startAll() {
      if (!this.$store.dbLoaded) {
        setTimeout(this.startAll, 300);
      } else if (this.$store.sugarData) {
        if (this.$store.sugarData.getCollection('entries').find().length) {
          this.$router.push('/dashboard');
        }
      }
    },
  },
  mounted() {
    this.startAll();
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

.banner-area
  padding-bottom base-padding

.selecter
  text-align center
  padding base-padding
  p
    margin-top 20px
    font-style italic
  img
    width 40%
    display block
    margin auto
    margin-bottom 25px
  &:first-child
    border-right 2px solid rgba(color-base, .15)
</style>



// WEBPACK FOOTER //
// src/components/pages/Start.vue